import { numberFormatter } from '../utils/numberFormatter';
import FinancialData from './common/FinancialData';

interface SummaryProps {
  title: string;
  annualRevenue: number;
  rebuildTime: number;
  totalRevenueExposure: number;
  finishedGoodsInventory?: number;
  finishedGoodsInventoryPercentage?: number;
  internalMitigation?: number;
  internalMitigationPercentage?: number;
  externalMitigation?: number;
  totalmitigationPercentage?: number;
  externalMitigationPercentage?: number;
  totalMitigation: number;
  residualRevenueExposure: number;
}

export const Summary: React.FC<SummaryProps> = ({
  title,
  annualRevenue,
  rebuildTime,
  totalRevenueExposure,
  finishedGoodsInventory,
  finishedGoodsInventoryPercentage,
  internalMitigation,
  internalMitigationPercentage,
  externalMitigation,
  totalmitigationPercentage,
  externalMitigationPercentage,
  totalMitigation,
  residualRevenueExposure,
}) => {
  const showExternalMitigation =
    externalMitigation !== undefined &&
    externalMitigationPercentage !== undefined;

  const showInternalMitigation =
    internalMitigation !== undefined &&
    internalMitigationPercentage !== undefined;

  const showfinishedGoodsInventory =
    finishedGoodsInventory !== undefined &&
    finishedGoodsInventoryPercentage !== undefined;

  return (
    <div className="w-full">
      <h1 className="font-bold text-primary-200 text-lg tracking-ultraWidest">
        {title}
      </h1>
      <div className="my-4 flex flex-col flex-nowrap w-full items-center justify-center">
        <div className="w-full flex flex-row flex-nowrap border-b">
          <div className="border-r pr-5 flex flex-col items-end w-48">
            <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
              {<FinancialData text={annualRevenue} />}
            </h3>
            <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
              {rebuildTime} {' MONTHS'}
            </h3>
            <h3 className="my-3 font-bold text-sm text-primary-200 tracking-widest">
              {<FinancialData text={totalRevenueExposure} />}
            </h3>
          </div>
          <div className="border-l pl-8 flex flex-col items-start">
            <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
              Annual Revenue Supported
            </h3>
            <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
              Rebuild Time
            </h3>
            <h3 className="my-3 font-bold text-sm text-primary-200 tracking-widest">
              Total Revenue Exposure
            </h3>
          </div>
        </div>
        <div className="w-full flex flex-row flex-nowrap border-y">
          <div className="border-r pr-5 flex flex-col items-end w-48">
            {showfinishedGoodsInventory && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                {<FinancialData text={finishedGoodsInventory} />}
                {`(${finishedGoodsInventoryPercentage}%)`}
              </h3>
            )}
            {showInternalMitigation && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                {<FinancialData text={internalMitigation} />}
                {`(${internalMitigationPercentage}%)`}
              </h3>
            )}
            {showExternalMitigation && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                {<FinancialData text={externalMitigation} />}
                {`(${externalMitigationPercentage}%)`}
              </h3>
            )}
            <h3 className="my-3 font-bold text-sm text-primary-200 tracking-widest">
              {<FinancialData text={totalMitigation} />}
              {`(${totalmitigationPercentage}%)`}
            </h3>
          </div>
          <div className="border-l pl-8 flex flex-col items-start">
            {showfinishedGoodsInventory && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                Finished Goods Inventory
              </h3>
            )}
            {showInternalMitigation && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                Internal Mitigation Sources
              </h3>
            )}
            {showExternalMitigation && (
              <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
                External Mitigation Sources
              </h3>
            )}
            <h3 className="my-3 font-normal text-sm text-primary-200 tracking-widest">
              Total Mitigation
            </h3>
          </div>
        </div>
        <div className="w-full flex flex-row flex-nowrap border-t">
          <div className="py-3 border-r pr-5 flex flex-col items-end w-48">
            <h3 className="font-bold text-sm text-primary-200 tracking-widest">
              {<FinancialData text={residualRevenueExposure} />}
            </h3>
          </div>
          <div className="py-3 border-l pl-8 flex flex-col items-start">
            <h3 className="font-bold text-sm text-primary-200 tracking-widest">
              Residual Revenue Exposure
            </h3>
            <span className="text-xsm text-primary-200 italic">
              *for rebuild time above
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
